import loadDataIntoLocalStorage from '@godaddy/split-data-loader'

import { getSubjectKey } from '@godaddy/hivemind-common'

export default function loadStorage ({
  app,
  idType,
  id,
  preloadLocation = '__splitCachePreload',
  windowOverride = window,
  loadData = loadDataIntoLocalStorage
}) {
  loadData({
    serializedData: windowOverride[preloadLocation],
    userId: getSubjectKey({ idType, id }),
    storagePrefix: `${app}.${idType}`
  })
  return !!windowOverride[preloadLocation]
}
